import { z } from 'zod';
/**
 * Timing for a single pipeline step.
 */
export const StepTimingSchema = z.object({
    name: z.string(),
    durationMs: z.number(),
});
/**
 * Ollama inference metrics — extracted from the /api/chat response.
 * Durations converted from nanoseconds to milliseconds.
 */
export const OllamaMetricsSchema = z.object({
    totalDurationMs: z.number(),
    loadDurationMs: z.number(),
    promptTokens: z.number(),
    promptEvalMs: z.number(),
    completionTokens: z.number(),
    completionEvalMs: z.number(),
    tokensPerSecond: z.number(),
});
/**
 * Hardware and model context for the inference run.
 */
export const InferenceContextSchema = z.object({
    model: z.string(),
    task: z.string(),
    ollamaHost: z.string(),
    hostname: z.string(),
    timestamp: z.string(),
    platform: z.string().optional(),
    arch: z.string().optional(),
    cpuModel: z.string().optional(),
    cpuCores: z.number().optional(),
    totalMemoryGb: z.number().optional(),
    freeMemoryGb: z.number().optional(),
});
/**
 * Full query performance stats — shared by API, web, CLI, and ops agent.
 */
export const QueryStatsSchema = z.object({
    totalDurationMs: z.number(),
    steps: z.array(StepTimingSchema),
    inference: OllamaMetricsSchema.optional(),
    commentaryInference: OllamaMetricsSchema.optional(),
    context: InferenceContextSchema,
    digest: z.string().optional(),
});
//# sourceMappingURL=query-stats.js.map